import { ProjectConfig, UserForResolver } from "db/definitions";
import { useEffect, useState } from "react";
import { v4 as uuid } from "uuid";
import { batchCreateProjectConfigs, batchDeleteProjectConfigs, getAllProjectConfigs } from "../db/queries/projectConfigQueries";

function useProjectConfigs(userDoc: UserForResolver | null | undefined) {
	const [projectConfigs, setProjectConfigs] = useState<ProjectConfig[]>([]);

	useEffect(() => {
		async function setupProjectConfigs() {
			const retrievedProjectConfigs = await getAllProjectConfigs();
			setProjectConfigs(retrievedProjectConfigs);
		}

		setupProjectConfigs();
	}, []);

	async function addProjectConfigs(projectIds: string[]): Promise<void> {
		if (userDoc) {
			const projectConfigsCopy = [...projectConfigs];
			const projectConfigsToCreate = [];
			const timestamp = new Date().toISOString();
			for (let i = 0; i < projectIds.length; i++) {
				const projectId = projectIds[i];
				const projectConfigObj = {
					id: uuid(),
					userId: userDoc.id,
					createdAt: timestamp,
					updatedAt: timestamp,
					projectId,
				};
				projectConfigsToCreate.push(projectConfigObj);
			}

			await batchCreateProjectConfigs(projectConfigsToCreate);

			const finalProjectConfigs = projectConfigsCopy.concat(projectConfigsToCreate);
			setProjectConfigs(finalProjectConfigs);
		}
	}

	async function removeProjectConfigs(projectConfigIdsToRemove: string[]): Promise<void> {
		const result = await batchDeleteProjectConfigs(projectConfigIdsToRemove);
		return result;
	}

	const results = {
		projectConfigs,
		addProjectConfigs,
		removeProjectConfigs,
	};

	return results;
}

export default useProjectConfigs;
